import { render, staticRenderFns } from "./SelectPrincipal.vue?vue&type=template&id=1ffdc619&scoped=true&"
import script from "./SelectPrincipal.vue?vue&type=script&lang=js&"
export * from "./SelectPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./SelectPrincipal.vue?vue&type=style&index=0&id=1ffdc619&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffdc619",
  null
  
)

export default component.exports